import { Variables } from "../graphql";
import { GqlObj, isGqlObject } from "../graphql/types";
import { BaseQueryKey } from "../query/types";
import { hasOwnProperty } from "../utils";

export type QueryKey<TVars extends Variables | undefined = undefined> = [
  string,
  {
    query: GqlObj;
    graphQLEndpoint: string;
    variables: TVars | undefined;
  }
];

export const isQueryKey = (queryKey: BaseQueryKey): queryKey is QueryKey => {
  return (
    Array.isArray(queryKey) &&
    typeof queryKey[0] === "string" &&
    hasOwnProperty(queryKey[1], "query") &&
    isGqlObject(queryKey[1].query)
  );
};
